import { render, staticRenderFns } from "./AdminPanelEpicentrkShoppingPacket.vue?vue&type=template&id=726aca01&"
import script from "./AdminPanelEpicentrkShoppingPacket.vue?vue&type=script&lang=js&"
export * from "./AdminPanelEpicentrkShoppingPacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports